<template>
  <div id="app" class="app">
    <!--  顶部导航兰  -->
    <header-bar />
    <!--  页面容器  -->
    <router-view />
    <!--  底部  -->
    <footer-bar />
  </div>
</template>

<script>
import HeaderBar from "@/components/HeaderBar.vue";
import FooterBar from "@/components/FooterBar.vue";

export default {
  name: "App",
  components: {
    HeaderBar,
    FooterBar
  },
  data() {
    return {};
  }
};
</script>
<style lang="less">
@import './assets/styles/common.css';
</style>



// WEBPACK FOOTER //
// src/App.vue